<template>
	<div id="app">
		<Tab @toggleForm="toggleForm" />
		<keep-alive>
			<transition name="shine">
				<router-view
					@toggleForm="toggleForm"
					v-if="$route.meta.keep_alive"
				></router-view>
			</transition>
		</keep-alive>
		<transition name="shine">
			<router-view
				@toggleForm="toggleForm"
				v-if="!$route.meta.keep_alive"
			></router-view>
		</transition>
		<div class="_footer" >
			<div class="logo_footer">
        <img :src="logo_bg" />
			  <img :src="logo0_bg" />
      </div>
      <p>{{webInfo.record}}</p>
		</div>
		<PopUp :form_msg="form_msg" />
	</div>
</template>

<script>
import Vue from "vue";
import Tab from "../components/Tab";
import SideBar from "../components/SideBar";
import PopUp from "../components/PopUp";
import { mapState, mapActions } from "vuex";
import util from "@/util/util.js";
import CONSTANT from '@/util/constant';
export default {
	name: "App",
	computed: {
		...mapState({
			common: (state) => state.common,
		}),
		logo_bg() {
			return require("../../static/wangyi.png");
		},
		logo0_bg() {
			return require("../../static/youdao.png");
		},
	},

	components: {
		Tab,
		SideBar,
		PopUp,
	},
	data() {
		return {
			form_msg: {},
			appStyle: {},
			webInfo: CONSTANT.WEB_INFO
		};
	},
	mounted() {
		window._hmt &&
			window._hmt.push([
				"_trackEvent",
				"pageview",
				this.$route.path.slice(1),
			]);
    
	},
	methods: {
		toggleForm(flag) {
			this.form_msg = {
				show: true,
				form_type: flag,
			};
		},
	},
};
</script>

<style scoped>
._footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 15px;
}
.logo_footer {
	display: flex;
	align-items: center;
  justify-content: center;
  height: 50px;
  padding: 10px 0 10px;
}

.logo_footer img {
	display: block;
	width: auto;
	height: 100%;
	transform: scale(0.85);
}


#app {
	padding-top: 60px;
}
/* 进出场动画 */
.shine-enter-active,
.shine-leave-active {
	transition: opacity 0.2s;
}
.shine-enter, .shine-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/containers/App.vue